import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import Card from '../../node_modules/reactstrap/esm/Card.js';
import CardBody from '../../node_modules/reactstrap/esm/CardBody.js';
import CardHeader from '../../node_modules/reactstrap/esm/CardHeader.js';
import Theme from '../../Theme/index.js';

var _templateObject, _templateObject2;
var HeadedBoard = styled(Card)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-basis: 49%;\n  margin-bottom: 30px;\n  border-radius: 0;\n  border: none;\n\n  @media (max-width: 767px) {\n    flex-basis: 100%;\n  }\n"])));
var SolidHeader = styled(CardHeader).attrs({
  className: "solid-header"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: white;\n  text-align: center;\n  font-family: ", ";\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: -0.14px;\n  line-height: 22px;\n\n  &.solid-header {\n    border-radius: 0;\n  }\n"])), function (_ref) {
  var headerBkg = _ref.headerBkg;
  return headerBkg;
}, Theme.fonts.Montserrat);
var index = (function (_ref2) {
  var header = _ref2.header,
    children = _ref2.children,
    headerBkg = _ref2.headerBkg;
  return /*#__PURE__*/React__default.createElement(HeadedBoard, null, /*#__PURE__*/React__default.createElement(SolidHeader, {
    headerBkg: headerBkg
  }, header), /*#__PURE__*/React__default.createElement(CardBody, null, children));
});

export { HeadedBoard, SolidHeader, index as default };
